import React, { useState, useEffect } from "react";
import {
  Dialog,
  Paper,
  Button,
  TextField,
  Select,
  MenuItem,
  Box,
  Typography,
  Alert,
} from "@mui/material";

const EditComplaint = ({ open, onClose, onSubmit, complaint }) => {
  const [updatedData, setUpdatedData] = useState({
    type: "",
    description: "",
  });

  const [errors, setErrors] = useState({ type: false, description: false });

  useEffect(() => {
    if (complaint) {
      setUpdatedData({
        type: complaint.type,
        description: complaint.description,
      });
    }
  }, [complaint]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdatedData((prev) => ({ ...prev, [name]: value }));

    // إزالة الخطأ بمجرد أن المستخدم يكتب
    setErrors((prevErrors) => ({ ...prevErrors, [name]: value.trim() === "" }));
  };

  const handleSubmit = () => {
    const newErrors = {
      type: updatedData.type.trim() === "",
      description: updatedData.description.trim() === "",
    };

    setErrors(newErrors);

    if (!newErrors.type && !newErrors.description) {
      onSubmit(complaint.id, updatedData);
    }
  };

  const isFormValid =
    updatedData.type.trim() !== "" && updatedData.description.trim() !== "";

  // السماح بالتعديل فقط إذا كانت الشكوى في حالة "قيد الانتظار"
  const canEdit = complaint?.status === "قيد المراجعة";

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <Paper sx={{ p: 3, direction: "rtl" }}>
        <Typography
          variant="h5"
          sx={{ mb: 3, fontFamily: "Cairo", textAlign: "center" }}
        >
          تعديل الشكوى
        </Typography>

        {/* عرض تنبيه في حالة عدم إمكانية التعديل */}
        {!canEdit && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            لا يمكن تعديل هذه الشكوى لأنها ليست في حالة <strong>قيد الانتظار</strong>.
          </Alert>
        )}

        <Box sx={{ mb: 2 }}>
          <Select
            name="type"
            fullWidth
            value={updatedData.type}
            onChange={handleChange}
            displayEmpty
            error={errors.type}
            disabled={!canEdit} // تعطيل التعديل إذا لم يكن بالإمكان
          >
            <MenuItem value="" disabled>
              اختر نوع الشكوى
            </MenuItem>
            <MenuItem value="موافقة أمنية">موافقة أمنية</MenuItem>
            <MenuItem value="شكوى إدارية">شكوى إدارية / بلاغ</MenuItem>
            <MenuItem value="فساد">فساد / تلاعب</MenuItem>
          </Select>
          {errors.type && (
            <Typography color="error" sx={{ fontSize: "12px", mt: 1 }}>
              يجب اختيار نوع الشكوى
            </Typography>
          )}
        </Box>

        <TextField
          fullWidth
          multiline
          rows={4}
          label="تفاصيل الشكوى"
          name="description"
          value={updatedData.description}
          onChange={handleChange}
          error={errors.description}
          helperText={errors.description ? "يجب إدخال تفاصيل الشكوى" : ""}
          sx={{ mb: 3 }}
          disabled={!canEdit} // تعطيل التعديل إذا لم يكن بالإمكان
        />

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* السماح بالتعديل فقط إذا كانت الشكوى في "قيد الانتظار" */}
          {canEdit ? (
            <Button
              variant="contained"
              onClick={handleSubmit}
              disabled={!isFormValid}
              sx={{
                bgcolor: "#2196f3",
                color: "#fff",
                "&:hover": { bgcolor: "#1769aa" },
              }}
            >
              حفظ التعديلات
            </Button>
          ) : (
            <Button variant="contained" disabled sx={{ opacity: 0.5 }}>
              غير قابل للتعديل
            </Button>
          )}

          <Button
            variant="outlined"
            onClick={onClose}
            sx={{
              bgcolor: "#f44336",
              color: "#fff",
              "&:hover": { bgcolor: "#d32f2f" },
            }}
          >
            إلغاء
          </Button>
        </Box>
      </Paper>
    </Dialog>
  );
};

export default EditComplaint;
